import { render } from "./StudiesTable.vue?vue&type=template&id=72ebd844&scoped=true"
import script from "./StudiesTable.vue?vue&type=script&lang=js"
export * from "./StudiesTable.vue?vue&type=script&lang=js"

import "./StudiesTable.vue?vue&type=style&index=0&id=72ebd844&lang=css"
import "./StudiesTable.vue?vue&type=style&index=1&id=72ebd844&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\DicomServerStudiesList\\DicomStudyListVueClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72ebd844"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTr,QTh,QBtn,QTd,QIcon,QInnerLoading,QSpinnerHourglass,QField});
